<template>
  <div>
    <div
      class="table_info"
      :key="`config-${index_}`"
      v-for="(el, index_) in tableData"
    >
      <div class="info-one info_one_index">
        <span> {{ index_ > 9 ? index_ : "0" + (index_ + 1) }}</span>
        <span class="flex_wrapper" v-if="isEdit">
          <van-button  @click="add()" type="info" size="mini">新增</van-button>
          <van-button @click="del(index_)" type="danger" size="mini">删除</van-button>   
        </span>
      </div>
      <div
        class="info-one"
        :key="`${item.prop}-${index}`"
        v-for="(item, index) in tableConfig"
      >
        <div class="info-left">{{ item.label }}</div>
        <template  v-if="item.slot">
        
          <slot :name="item.prop" :index="index_" :item="item"> </slot>
        </template>
        <div
          class="info-right"
          v-else-if="item.propInner && item.propInner != ''"
        >
          {{ el[item.prop][item.propInner]?el[item.prop][item.propInner]:'无' }}
        </div>
        <div class="info-right" v-else>{{
                item.formatter
                  ? item.formatter(item.label, el[item.prop])
                  : el[item.prop]?el[item.prop]:'无'
                }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tableDetail",
  data() {
    return {
      addObj:{}
    };
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableConfig: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {

  },
  mounted() {
    let addObj = {};
    this.tableConfig.map((item) => {
      addObj[item.prop] = undefined;
    });
    this.addObj = addObj;
  },
  methods: {
    del(index) {
      let that = this;
      if (this.tableData.length == 1) {
        this.$message.error("至少保留一条数据!");
        return;
      }
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.tableData.splice(index, 1);
        
      });
    },
    add() {
      let addObj = JSON.parse(JSON.stringify(this.addObj));
      this.tableData.push(addObj);
    },

  }
};
</script>
<style lang="scss" scoped>
.info-one {
  background-color: #fff;
  border-top: 0.5px solid #f2f2f2;
  border-bottom: 0.5px solid #f2f2f2;
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.2rem;
  .header_title {
  }

  .info-left {
    width: 35%;
    color: #999;
    font-size: 0.38rem;
  }
  .info-right {
    width: 65%;
    font-size: 0.38rem;
    text-align: right;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
  }
}

.item-one {
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  padding: 0.35rem 0.4rem;
  border-radius: 0.2rem;
  margin-bottom: 0.2rem;
  .item-index {
    font-size: 0.38rem;
    line-height: 0.7rem;
    color: #999;
    font-weight: 600;
  }
  .item-line {
    font-size: 0.38rem;
    line-height: 0.55rem;
    color: #999;
    span {
      margin-left: 0.3rem;
    }
  }
  .remark-content {
    font-size: 0.38rem;
    color: #333;
    line-height: 0.7rem;
  }
}
.table_info {
  margin-bottom: 0.1rem;

  .info_one_index {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 0.1rem;
      height: 100%;
      background: #409eff;
    }
  }
}
.flex_wrapper {
  display: flex;
  align-items: center;
}
</style>